import { useEffect } from 'react';
import { THEME_CONFIG } from '@/lib/config';

/**
 * Hook to apply theme colors from environment variables to CSS custom properties
 * This runs once on app load and applies the colors globally
 */
export const useTheme = () => {
  useEffect(() => {
    applyColorsToCSS();
  }, []);

  const applyColorsToCSS = () => {
    if (typeof window === 'undefined') return;

    const root = document.documentElement;
    
    // Apply colors from environment variables to CSS custom properties
    root.style.setProperty('--aralin-color', THEME_CONFIG.PRIMARY_COLOR);
    root.style.setProperty('--aralin-bg', THEME_CONFIG.BACKGROUND_COLOR);
    root.style.setProperty('--aralin-sidebar-text', THEME_CONFIG.SIDEBAR_TEXT_COLOR);
    root.style.setProperty('--aralin-gradient', THEME_CONFIG.GRADIENT_HERO);
  };

  return {
    themeConfig: THEME_CONFIG,
    applyColorsToCSS,
  };
};
